import React, { Fragment, useContext, useEffect, useState } from "react";
import { Btn, H3 } from "../../../AbstractElements";
import { useForm } from "react-hook-form";
import { Cancel, Save } from "../../../Shared/Constants";
import { Card, CardBody, Col, Form, FormGroup, Label, Row } from "reactstrap";
import FilesUploader from "./FilesUploader";
import NoteContext from "../Context/Index";
import FormLinksComponent from "./FormLinksComponent";
import { MODEL_TYPE_ENUM } from "../../../Shared/Constants/enums";
import LinkContext from "../../Links/Context/Index";
import FileContext from "../../Files/Context/Index";
import InputError from "../../../Shared/Components/Form/InputError";
import { togleLoading } from "../../../Shared/Utils/alertLoading";

import FormAddUserComponent from "./FormAddUserComponent";
import FormAddContactComponent from "./FormAddContactComponent";
import ContactListComponent from "./ContactListComponent";
import UserListComponent from "./UserListComponent";
import { getNoteModelsApi } from "../../../Shared/Api/GetNoteModelsApi";
import { SUCCESS_API_RESPONSE } from "../../../Shared/Constants/api";
import { FormatNoteHasModelList } from "../../../Shared/Utils/Formatters/FormarNoteHasModel";
import EmptyState from "../../../Shared/Components/EmptyState";

export default function NoteForm({ modalTogle, contact_id }) {
  const { createItem, item, updateItem, setItem, readOnly, saving, isAdding } =
    useContext(NoteContext);

  const [currentUsers, setCurrentUsers] = useState([]);
  const [currentContacts, setCurrentContacts] = useState([]);

  const fetchCurrentUsers = async () => {
    const response = await getNoteModelsApi(item.id, {
      model_type: MODEL_TYPE_ENUM.USER,
    });
    if (response.result === SUCCESS_API_RESPONSE) {
      const formattedUsers = FormatNoteHasModelList(response.data?.items);
      setCurrentUsers(formattedUsers);
    }
  };

  const fetchCurrentContacts = async () => {
    const response = await getNoteModelsApi(item.id, {
      model_type: MODEL_TYPE_ENUM.CONTACT,
    });
    if (response.result === SUCCESS_API_RESPONSE) {
      const formattedContacts = FormatNoteHasModelList(response.data?.items);
      setCurrentContacts(formattedContacts);
    }
  };

  const {
    fetchItems: fetchLinkItems,
    currentPage: currentPageLinks,
    rowsPerPage: rowsPerPageLinks,
    setItems: setLinks,
    items: links,
    setFilters: setFiltersLinks,
    filters: filtersLinks,
  } = useContext(LinkContext);

  const {
    fetchItems: fetchFileItems,
    currentPage: currentPageFiles,
    rowsPerPage: rowsPerPageFiles,
    setItems: setFiles,
    items: files,
    setFilters: setFiltersFiles,
    filters: filtersFiles,
  } = useContext(FileContext);

  const {
    register,
    handleSubmit,
    reset,

    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    let payload = {
      ...data,
      links: links,
      files: files,
      contact_id: contact_id,
      users: currentUsers,
      contacts: currentContacts,
    };
    if (item && item?.id) {
      updateItem(payload, item?.id);
    } else {
      createItem(payload);
    }
  };

  //contenido iniical del formulario en caso de que sea edicion
  useEffect(() => {
    console.log(item);

    if (item?.data) {
      const parsedData = JSON.parse(item?.data);
      reset({
        content: parsedData?.content,
      });
    }
    if (item?.content) {
      reset({
        content: item?.content,
      });
    }
    if (item?.id) {
      fetchCurrentUsers();
      fetchCurrentContacts();
    }

    setFiltersLinks({
      ...filtersLinks,
      model_id: item?.id,
      model_type: MODEL_TYPE_ENUM.NOTE,
    });

    setFiltersFiles({
      ...filtersFiles,
      model_id: item?.id,
      model_type: MODEL_TYPE_ENUM.NOTE,
    });
  }, [item]);

  useEffect(() => {
    //me aseguro de tener los filtros de los links inicalizados antes de hacer el requets
    if (filtersLinks?.model_id && filtersLinks?.model_type) {
      fetchLinkItems(currentPageLinks, rowsPerPageLinks);
    }
  }, [filtersLinks]);

  useEffect(() => {
    //me aseguro de tener los filtros de los files inicalizados antes de hacer el requets
    if (filtersFiles?.model_id && filtersFiles?.model_type) {
      fetchFileItems(currentPageFiles, rowsPerPageFiles);
    }
  }, [filtersFiles]);

  useEffect(() => {
    return () => {
      setItem({});
      setCurrentUsers([]);
      setCurrentContacts([]);
    };
  }, []);

  useEffect(() => {
    togleLoading(saving);
  }, [saving]);

  return (
    <>
      <Fragment>
        <Col md="12">
          <Card>
            <CardBody style={{ backgroundColor: "#f5f5f5" }}>
              {item?.id || isAdding ? (
                <Form onSubmit={handleSubmit(onSubmit)} id="noteForm">
                  <Row className="mb-5">
                    <Col>
                      <FormGroup className="m-0">
                        <Label>Descripción</Label>
                        <textarea
                          className={`form-control ${
                            errors.content && "is-invalid"
                          }`}
                          disabled={readOnly}
                          type="textarea"
                          rows="3"
                          {...register("content", {
                            required: "El contenido de la nota es obligatorio",
                          })}
                        />
                        <InputError errors={errors} name="content" />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md="6">
                      <FormAddContactComponent
                        setCurrentContacts={setCurrentContacts}
                        currentContacts={currentContacts}
                      ></FormAddContactComponent>
                      <ContactListComponent
                        contacts={currentContacts}
                        setContacts={setCurrentContacts}
                      />
                    </Col>
                    <Col md="6">
                      <FormAddUserComponent
                        setCurrentUsers={setCurrentUsers}
                        currentUsers={currentUsers}
                      ></FormAddUserComponent>
                      <UserListComponent
                        users={currentUsers}
                        setUsers={setCurrentUsers}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-5">
                    <Col>
                      <FormLinksComponent
                        links={links}
                        setLinks={setLinks}
                        model_id={item?.id}
                        model_type={MODEL_TYPE_ENUM.NOTE}
                        readOnly={readOnly}
                      ></FormLinksComponent>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup className="m-form__group w-100">
                        {!readOnly && (
                          <Label className="mb-2">
                            <div className="w-100">
                              Seleccione los documentos relevantes para
                              completar su nota
                            </div>
                          </Label>
                        )}

                        <div className="w-100">
                          <FilesUploader
                            readOnly={readOnly}
                            files={files}
                            setFiles={setFiles}
                          ></FilesUploader>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-end">
                      <Btn
                        attrBtn={{
                          color: "outline-light",
                          className: "ms-1 border",
                          onClick: modalTogle,
                        }}
                      >
                        {Cancel}
                      </Btn>
                      <Btn
                        attrBtn={{
                          type: "submit",
                          form: "noteForm",
                          className: "ms-1",
                          color: `primary`,
                          // color: `${isDirty ? "primary" : "secondary"}`,
                          disabled: readOnly,
                        }}
                      >
                        {Save}
                      </Btn>
                    </Col>
                  </Row>
                </Form>
              ) : (
                <EmptyState msg="No hay nota" />
              )}
            </CardBody>
          </Card>
        </Col>
      </Fragment>
    </>
  );
}
